import { render, staticRenderFns } from "./VolunteerPartnerSignupView.vue?vue&type=template&id=0244a970&scoped=true&"
import script from "./VolunteerPartnerSignupView.vue?vue&type=script&lang=js&"
export * from "./VolunteerPartnerSignupView.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerPartnerSignupView.vue?vue&type=style&index=0&id=0244a970&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244a970",
  null
  
)

export default component.exports